// extracted by mini-css-extract-plugin
module.exports = {"margin":"margin____6FJo","root":"root___13CS_"};